// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FC } from 'react';

import { RouteProps, Route, Redirect } from 'react-router-dom';

interface CustomRouteProps extends RouteProps {
  isPrivate?: boolean;
}

const CustomRoute: FC<CustomRouteProps> = ({ isPrivate, ...rest }) => {
  return isPrivate ? <Redirect to="/" /> : <Route {...rest} />;
};

export default CustomRoute;
